export enum ReplenishmentPickProductErrorCodes {
  PRODUCTS_NOT_AVAILABLE_AT_SAME_WAREHOUSE = "PRODUCTS_NOT_AVAILABLE_AT_SAME_WAREHOUSE",
  WAREHOUSE_WITH_INVENTORY_LESS_THAN_CASE_QTY = "WAREHOUSE_WITH_INVENTORY_LESS_THAN_CASE_QTY",
  PRODUCT_NOT_AVAILABLE_IN_ANY_WAREHOUSE = "PRODUCT_NOT_AVAILABLE_IN_ANY_WAREHOUSE",
  KIT_COMPONENTS_NOT_AVAILABLE_AT_SAME_WAREHOUSE = "KIT_COMPONENTS_NOT_AVAILABLE_AT_SAME_WAREHOUSE",
}
